import React, { useState, useEffect } from "react";
import logoImg from "../assets/images/logo_blue.png";
import "../styles/NavBar.css";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const [isHovered, setIsHovered] = useState(false);
  const [isLoginDropdownOpen, setIsLoginDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const navbarHeight = 80; // Adjust based on your navbar height
      const targetPosition = targetElement.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
    // Set active tab
    setActiveTab(targetId);
    // Close mobile menu after clicking
    setIsMenuOpen(false);
  };

  const handleLoginHover = () => {
    setIsLoginDropdownOpen(true);
  };

  const handleLoginLeave = () => {
    setIsLoginDropdownOpen(false);
  };

  const handleLoginClick = (loginType) => {
    // Handle login redirection based on type
    if (loginType === 'admin') {
      window.location.href = 'https://super-admin.medigrowhub.com/'; // Replace with your admin subdomain
    } else if (loginType === 'bloodbank') {
      window.location.href = 'https://blood-bank-admin.medigrowhub.com/'; // Replace with your bloodbank subdomain
    }
    setIsLoginDropdownOpen(false);
    setIsMenuOpen(false);
  };

  // Update active tab based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const homeSection = document.getElementById("home");
      const servicesSection = document.getElementById("services");
      const scrollPosition = window.scrollY + 100;

      if (servicesSection && scrollPosition >= servicesSection.offsetTop) {
        setActiveTab("services");
      } else if (homeSection) {
        setActiveTab("home");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest(".navbar-container")) {
        setIsMenuOpen(false);
      }
      if (isLoginDropdownOpen && !event.target.closest(".login-dropdown-container")) {
        setIsLoginDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMenuOpen, isLoginDropdownOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-brand">
          <a
            href="#home"
            className="logo"
            onClick={(e) => handleNavClick(e, "home")}
          >
            <img src={logoImg} alt="MediGrow" className="logo-img" />

            <p>
              <span className="logo-text-medi">MEDI</span>
              <span className="logo-text-grow">GROW</span>
            </p>
          </a>
        </div>

        {/* Desktop Navigation */}
        <ul className="navbar-nav desktop-nav">
          <li>
            <a
              href="#home"
              className={`nav-link ${activeTab === "home" ? "active" : ""}`}
              onClick={(e) => handleNavClick(e, "home")}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#services"
              className={`nav-link ${activeTab === "services" ? "active" : ""}`}
              onClick={(e) => handleNavClick(e, "services")}
            >
              Our Services
            </a>
          </li>
          <li 
            className="login-dropdown-container"
            onMouseEnter={handleLoginHover}
            onMouseLeave={handleLoginLeave}
          >
            <a
              href="#"
              className="nav-link"
              onClick={(e) => e.preventDefault()}
            >
              Login
              <i className="bi bi-chevron-down" style={{ marginLeft: '5px', fontSize: '0.8rem' }}></i>
            </a>
            {isLoginDropdownOpen && (
              <div className="login-dropdown">
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLoginClick('admin');
                  }}
                >
                  Admin Login
                </a>
                <a
                  href="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLoginClick('bloodbank');
                  }}
                >
                  Blood Bank Admin Login
                </a>
              </div>
            )}
          </li>
        </ul>

        {/* Desktop App Badges */}
        <div className="app-badges desktop-badges">
          <a href="#" className="app-badge app-store">
            <i className="bi bi-apple"></i>
            App Store
          </a>
          <a href="#" className="app-badge google-play">
            <i className="bi bi-google-play"></i>
            Google Play
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          <i className={`bi ${isMenuOpen ? "bi-x" : "bi-list"}`}></i>
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
          <ul className="navbar-nav mobile-nav">
            <li>
              <a
                href="#home"
                className={`nav-link ${activeTab === "home" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "home")}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#services"
                className={`nav-link ${
                  activeTab === "services" ? "active" : ""
                }`}
                onClick={(e) => handleNavClick(e, "services")}
              >
                Our Services
              </a>
            </li>
            <li className="mobile-login-section">
              <div className="mobile-login-header">Login</div>
              <div className="mobile-login-options">
                <a
                  href="super-admin.medigrowhub.com"
                  className="mobile-login-item"
                >
                  Admin Login
                </a>
                <a
                  href="blood-bank-admin.medigrowhub.com"
                  className="mobile-login-item"
                  
                >
                  Blood Bank Admin Login
                </a>
              </div>
            </li>
            <li>
              <div className="app-badges mobile-badges">
                <a href="#" className="app-badge app-store">
                  <i className="bi bi-apple"></i>
                  App Store
                </a>
                <a href="#" className="app-badge google-play">
                  <i className="bi bi-google-play"></i>
                  Google Play
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}